import { TranslateLoader } from '@ngx-translate/core';
import * as _ from 'lodash';

import { Observable, ReplaySubject } from 'rxjs';
import { map, take } from 'rxjs/operators';

export class CustomTranslationLoader implements TranslateLoader {
  private readonly translations: Record<string, unknown> = {};

  private readonly ready$ = new ReplaySubject<boolean>(1);

  constructor() {
    this.importAtCompileTime().then();
  }

  // eslint-disable-next-line
  getTranslation(lang: string): Observable<any> {
    return this.ready$
      .pipe(
        take(1),
        map(() => this.translations[lang]),
        map(result => result === undefined ? {} : result)
      );
  }

  private importAtCompileTime = async () => {
    this.addTranslations('en', await import('../../../../../assets/i18n/auth/en.json'));
    this.addTranslations('en', await import('../../../../../assets/i18n/amendment/en.json'));
    this.addTranslations('en', await import('../../../../../assets/i18n/claims/en.json'));
    this.addTranslations('en', await import('../../../../../assets/i18n/core/en.json'));
    this.addTranslations('en', await import('../../../../../assets/i18n/customer/en.json'));
    this.addTranslations('en', await import('../../../../../assets/i18n/public/en.json'));
    this.ready$.next(true);
  };

  // eslint-disable-next-line
  private addTranslations = (language: string, input: any) => {
    if (this.translations[language] === undefined) {
      this.translations[language] = {};
    }

    _.merge(this.translations[language], input);
  };
}
